import React from 'react'
import User from "../../../models/User";
import Page from '../../Page'

export default class ApplicationStartStep extends Page {

    static path = '/get-started';

    /**
     * The title shown on the form
     */
    static StepTitle = false;

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        if (!user.validateInfo()) return this;
        return false;
    };

    /**
     * Hide completion icon on sidebar
     */
    static NeedsCompletion = () => false;

    static hasCompleted(user) {
        return true;
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        return {}
    };

    static getPath(prefix = '/talent/application') {
        return `${prefix}${this.path}`
    }

    constructor(props) {
        super(props);
    }

    /**
     * The fields mapping for the form
     */
    static showFormButtons() {
        return false
    }

    /**
     * Render the form
     *
     * @returns {Form}
     */
    render() {
        let steps = TB.filter([...this.props.user.getApplicationStepsForTalent()], step => step.StepInfo);

        return (
            <div className="talent-start">
                <div className="white-panel container">
                    <h2 className="start-title">
                        <span>
                            Hi, <b>{this.props.user.first_name}</b>
                        </span>
                        <span>
                            {TB.trans('talent.get_started.start_title')}
                        </span>
                    </h2>

                    <div className="start-tile-container">
                        <div className="start-info">
                            <h5>
                                {TB.trans('talent.get_started.start_info')}
                            </h5>
                        </div>
                        {[
                            steps.map((step, index) => (
                                <div className="start-tile h-28" key={`start-tile${index}`}>
                                    <h5>
                                        {step.StepTitle || `Step ${index}`}
                                    </h5>
                                </div>
                            ))
                        ]}
                    </div>

                    <div className="flex items-center justify-center">
                        <button className="btn btn-primary" onClick={() => this.props.onSubmit()}>
                            {TB.trans('talent.get_started.btn_text')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}